import fetch from '@/assets/js/axios.js'
import { v4 as uuidv4 } from 'uuid'
import { DEVICE_MANAGE_SERVICE_API, MODEL_MANAGE_SERVICE_API, DEVICE_SHADOW_SERVICE_API } from './apis'
function getQueryParams (params) {
  const queryParams = {
    id: uuidv4(),
    timestamp: Date.parse(new Date()),
    version: '1.0',
    params: params
  }
  return queryParams
}

// function assignParams (params) {
//   const queryParams = {
//     id: uuidv4(),
//     timestamp: Date.parse(new Date()),
//     version: '1.0'
//   }
//   return Object.assign({}, queryParams, params)
// }

// 获取单个设设备列表
export function deviceList (params) {
  return fetch({
    url: DEVICE_MANAGE_SERVICE_API.DEVICE_LIST,
    method: 'post',
    data: getQueryParams(params)
  })
}
// 获取批次设备列表
export function getBatchDeviceList (params) {
  return fetch({
    url: DEVICE_MANAGE_SERVICE_API.DEVICE_BATCH_LIST,
    method: 'post',
    data: getQueryParams(params)
  })
}

// 启用设备
export function enableDevice (params) {
  return fetch({
    url: DEVICE_MANAGE_SERVICE_API.DEVICE_ENABLE,
    method: 'put',
    data: getQueryParams(params)
  })
}

// 禁用设备
export function disableDevice (params) {
  return fetch({
    url: DEVICE_MANAGE_SERVICE_API.DEVICE_DISABLE,
    method: 'put',
    data: getQueryParams(params)
  })
}

// 删除设备
export function deleteDevice (params) {
  return fetch({
    url: DEVICE_MANAGE_SERVICE_API.DEVICE_DELETE,
    method: 'delete',
    data: getQueryParams(params)
  })
}

// 添加设备
export function addDevice (params) {
  return fetch({
    url: DEVICE_MANAGE_SERVICE_API.DEVICE_ADD,
    method: 'post',
    data: getQueryParams(params)
  })
}

// 获取设备详情
export function deviceDetail (params) {
  return fetch({
    url: DEVICE_MANAGE_SERVICE_API.DEVICE_DETAIL,
    method: 'post',
    data: getQueryParams(params)
  })
}

// 获取批次管理设备详情
export function batchDeviceDetail (params) {
  return fetch({
    url: DEVICE_MANAGE_SERVICE_API.DEVICE_BATCH_DETAIL,
    method: 'post',
    data: getQueryParams(params)
  })
}

// 获取非法批次设备详情
export function batchErrorDeviceDetail (params) {
  return fetch({
    url: DEVICE_MANAGE_SERVICE_API.ERROR_DEVICE_BATCH_DETAIL,
    method: 'post',
    data: getQueryParams(params)
  })
}

// 修改设备
export function deviceEdit (params) {
  return fetch({
    url: DEVICE_MANAGE_SERVICE_API.DEVICE_UPDATE,
    method: 'put',
    data: getQueryParams(params)
  })
}

/// 根据productKey获取产品的物模型数据
export function thingModel (params) {
  return fetch({
    url: MODEL_MANAGE_SERVICE_API.THING_MODEL,
    method: 'post',
    data: getQueryParams(params)
  })
}
// 获取新增设备状态
export function addStatus (params) {
  return fetch({
    url: DEVICE_MANAGE_SERVICE_API.DEVICE_STATUS,
    method: 'post',
    data: getQueryParams(params),
    closeLoading: true
  })
}
// 导入文件
export function importFile (params) {
  return fetch({
    url: DEVICE_MANAGE_SERVICE_API.DEVICE_IMPORT_FILE,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
// 获取设备的topic列表
export function deviceTopic (params) {
  return fetch({
    url: DEVICE_MANAGE_SERVICE_API.DEVICE_TOPIC,
    method: 'post',
    data: getQueryParams(params)
  })
}

// 获取物模型运行状态列表数据
export function deviceShadow (params) {
  return fetch({
    url: DEVICE_SHADOW_SERVICE_API.DEVICE_SHADOWN,
    method: 'post',
    data: getQueryParams(params)
  })
}

// 获取某个运行状态的历史数据
export function historyProperties (params) {
  console.log('请求历史状态', JSON.stringify(getQueryParams(params)))
  return fetch({
    url: DEVICE_SHADOW_SERVICE_API.HISTORY_PROPERTIES,
    method: 'post',
    data: getQueryParams(params)
  })
}

// 服务运行状态历史数据
export function deviceServiceLog (params) {
  // console.log('请求历史状态', JSON.stringify(getQueryParams(params)))
  return fetch({
    url: DEVICE_SHADOW_SERVICE_API.DEVICE_SERVICE_LOG,
    method: 'post',
    data: getQueryParams(params)
  })
}

// 获取事件调用列表
export function deviceEventLogList (params) {
  return fetch({
    url: DEVICE_SHADOW_SERVICE_API.GET_DEVICE_EVENT_LOG_LIST,
    method: 'post',
    data: getQueryParams(params)
  })
}

// 下发指令
export function messageIssued (params) {
  return fetch({
    url: DEVICE_MANAGE_SERVICE_API.MESSAGE_ISSUED,
    method: 'post',
    data: getQueryParams(params)
  })
}

// -------------------子设备管理页面
// 获取子设备列表
export function subDeviceIdListPage (params) {
  return fetch({
    url: DEVICE_MANAGE_SERVICE_API.SUB_DEVICE_PAGE,
    method: 'post',
    data: getQueryParams(params)
  })
}
// 添加子设备
export function addSubDevice (params) {
  return fetch({
    url: DEVICE_MANAGE_SERVICE_API.ADD_SUB_DEVICE,
    method: 'post',
    data: getQueryParams(params)
  })
}
// 获取产品列表（网关设备）
export function subDeviceIdProductList (params) {
  return fetch({
    url: DEVICE_MANAGE_SERVICE_API.SUB_DEVICE_PRODUCT_LIST,
    method: 'post',
    data: getQueryParams(params)
  })
}
// 子设备详情
export function subDeviceDetail (params) {
  return fetch({
    url: DEVICE_MANAGE_SERVICE_API.SUB_DEVICE_DETAIT,
    method: 'post',
    data: getQueryParams(params)
  })
}
// 子设备详情
export function unbind (params) {
  return fetch({
    url: DEVICE_MANAGE_SERVICE_API.SUB_DEVICE_UNBIND,
    method: 'post',
    data: getQueryParams(params)
  })
}
